module.exports = __webpack_public_path__ + "img/huawei-app-gallery.9037c51.svg";